import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./BlackberryProducts.scss";

const bestSellerProducts = [
    {
        id: 1,
        name: "Linen Arc 2025",
        price: 7500,
        img:"/assets/img/elnora/rpone.jpg",
        tag: "Bestseller"
    },
    {
        id: 2,
        name: "Cotton Bliss 2025",
        price: 6500,
        img:"/assets/img/elnora/rptwo.webp",
        tag: "Bestseller"
    },
    {
        id: 3,
        name: "Saphire Paradise",
        price: 8500,
        img:"/assets/img/elnora/rpthree.webp",
        tag: "Bestseller"
    },
    {
        id: 4,
        name: "Blended Fabrico",
        price: 7500,
        img:"/assets/img/elnora/rpfour.jpeg",
        tag: "Bestseller"
    }
]

const newArrivalsProducts = [
    {
        id: 1,
        name: "Casa Blanca 2025",
        price: 1000,
        img:"/assets/img/elnora/rpfive.jpeg",
        tag: "New Arrival"
    },
    {
        id: 2,
        name: "Mont Blanc 2025",
        price: 2000,
        img:"/assets/img/elnora/rpsix.jpeg",
        tag: "New Arrival"
    },
    {
        id: 3,
        name: "Royale Winters",
        price: 3000,
        img:"/assets/img/elnora/rpseven.jpeg",
        tag: "New Arrival"
    },
    {
        id: 4,
        name: "Sapphire Paradise",
        price: 4000,
        img:"/assets/img/elnora/rpeight.jpeg",
        tag: "New Arrival"
    }
]

const BlackberryProducts = () => {
    const navigate = useNavigate()
    const [activeTab, setActiveTab] = useState('bestsellers');
    const products = activeTab === 'bestsellers' ? bestSellerProducts : newArrivalsProducts;

    return (
        <div className="blackberry-products">
            <div className="products-header">
                <h2>HERE FOR YOU</h2>
                <div className="tabs">
                    <button 
                        className={`tab ${activeTab === 'bestsellers' ? 'active' : ''}`}
                        onClick={() => setActiveTab('bestsellers')}
                    >
                        Bestsellers
                    </button>
                    <button 
                        className={`tab ${activeTab === 'new' ? 'active' : ''}`}
                        onClick={() => setActiveTab('new')}
                    >
                        New Arrivals
                    </button>
                </div>
            </div>

            <div className="products-grid">
                {products.map((product) => (
                    <div key={product.id} className="bb-product-card">
                        <div className="bb-product-image">
                            <img src={product.img} alt={product.name} />
                            <span className="bb-product-tag">{product.tag}</span>
                        </div>
                        <div className="bb-product-info">
                            <h3>{product.name}</h3>
                            <p className="price">₹{product.price}</p>
                        </div>
                    </div>
                ))}
            </div>

            <div className="view-all">
                <button className="view-all-btn" onClick={()=>{
                    navigate('/products-two')
                }}>
                    View All
                </button>
            </div>
        </div>
    );
};

export default BlackberryProducts;